import en from './common.en';

const enLocal = { en };

export default enLocal;
